import { useCallback, useRef, useState } from 'react';

import { AiTranscriptionConsentDialog } from '@/components/molecules/consent';
import { useAiTranscriptionConsentStore } from '@/stores/useAiTranscriptionConsentStore';

export const useAiTranscriptionConsentDialog = () => {
  const isAccepted = useAiTranscriptionConsentStore((state) => state.isAccepted);
  const acceptConsent = useAiTranscriptionConsentStore((state) => state.acceptConsent);
  const [visible, setVisible] = useState(false);
  const pendingAction = useRef<(() => void) | null>(null);

  const handleAccept = useCallback(
    (action: () => void) => {
      if (isAccepted) {
        action();

        return;
      }

      pendingAction.current = action;
      setVisible(true);
    },
    [isAccepted],
  );

  const handleAgree = useCallback(() => {
    void (async () => {
      await acceptConsent();
      setVisible(false);
      const action = pendingAction.current;
      pendingAction.current = null;
      action?.();
    })();
  }, [acceptConsent]);

  const handleDecline = useCallback(() => {
    setVisible(false);
    pendingAction.current = null;
  }, []);

  const consentDialog = (
    <AiTranscriptionConsentDialog
      visible={visible}
      onAgree={handleAgree}
      onDecline={handleDecline}
    />
  );

  return { handleAccept, consentDialog, isConsentVisible: visible };
};
